export function getPartnerAdAccountsUrl(target = '') {
  return `${configurationURL.angularDashboard.baseUrl}/#/settings/san${target}`;
}
